export const FormCreateDataPowerAvailable = {
  id: null,
  year: null,
  year_touched: false,
  power: null,
  power_touched: false,
  active: false,
  deleted: false,
  duplicate: false,
  is_touched: false,
  action: null,
};

export const FormValidasiDataPowerAvailable = {
  year: [(v) => !!v || "Tahun harus diisi"],
  power: [
    (v) => !!v?.trim() || "Daya harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Daya tidak boleh berakhir dengan koma.",
  ],
};
